import JoyField from '../types/JoyField';
import { isJoyChangeType } from '../validation/ModelValidation';
import { isString, isNumber } from '../validation/TypeChecking';
export default class JoyChange {
    /**
     * Creates a new JoyChange object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        if (!isString(data[JoyField.id])) {
            return null;
        }
        this.objectId = data[JoyField.id];
        if (!isJoyChangeType(data[JoyField.changeType])) {
            return null;
        }
        this.type = data[JoyField.changeType];
        if (!isNumber(data[JoyField.oldIndex])) {
            return null;
        }
        this.oldIndex = data[JoyField.oldIndex];
        if (!isNumber(data[JoyField.newIndex])) {
            return null;
        }
        this.newIndex = data[JoyField.newIndex];
    }
}
//# sourceMappingURL=JoyChange.js.map